<template>
<v-img src="https://esaj.ir/blog/wp-content/uploads/2021/01/57589707-640x392.jpg" max-width="70px"></v-img>
</template>

<script>
export default {
    name: "mci"
}
</script>

